// extracted by mini-css-extract-plugin
export default {"errorPageMain":"Error_errorPageMain__C8+DX","errorImage":"Error_errorImage__t6pQO","errorText":"Error_errorText__9mhcm"};